import { ReactNode } from "react";
import { useAuth } from "../context/AuthContext";

/** Renders children only if the current user has the given permission. */
export function Has({ perm, children }: { perm: string; children: ReactNode }) {
  const { isAdmin, permissions } = useAuth();
  if (isAdmin || permissions.has(perm)) {
    return <>{children}</>;
  }
  return null;
}
